import dataConfig from "../baseConfig/dataConfig";
import httpConfig from "../baseConfig/httpConfig";
import EventUtils from "./eventUtils.js";
import { isNumber } from "underscore";
import eventConfig from "../baseConfig/eventConfig";
import md5 from 'js-md5';

var tools = {};

/***
 * 获得浏览器的代理信息
 */
tools.getAgentInfo = function () {
    let label = {
        "phone": "unkown",
        "browser": "unkown"
    };

    if (window.navigator && window.navigator.userAgent) {
        let info = window.navigator.userAgent;
        let arr = info.split(")");
        let phoneArr = arr[0].split("(");
        if (phoneArr.length > 1) label['phone'] = phoneArr[1];
        if (arr.length > 1) {
            label['browser'] = arr[arr.length - 1];
        }
    }
    return label;
}

/**
 * 获得设备信息
 * @param {*} device 
 * @param {*} self 
 */
tools.getBaseInfo = function (device, self) {
    function getNetworkType() {
        var ua = navigator.userAgent;
        var networkStr = ua.match(/NetType\/\w+/) ? ua.match(/NetType\/\w+/)[0] : 'NetType/other';
        networkStr = networkStr.toLowerCase().replace('nettype/', '');
        var networkType = null;
        switch (networkStr) {
            case 'wifi':
                networkType = 'wifi';
                break;
            case '4g':
                networkType = '4g';
                break;
            case '3g':
                networkType = '3g';
                break;
            case '3gnet':
                networkType = '3g';
                break;
            case '2g':
                networkType = '2g';
                break;
            default:
                if (window.navigator.connection) {
                    networkType = window.navigator.connection.effectiveType;
                }
                if (!networkType) {
                    networkType = 'other';
                }
        }
        return networkType;
    }

    device['deviceHeight'] = window.innerHeight || 0;
    device['deviceWidth'] = window.innerWidth || 0;
    device['udid'] = tools.guid2();
    device['network'] = getNetworkType();
    device['lobbyVersion'] = "1.0.0";
    device['appVersion'] = "1.0.0";
    console.log(window.navigator);
    if (window.navigator) {
        device['osVersion'] = window.navigator.appVersion || "";
        device['open_info'] = window.navigator.userAgent || "";
    }
}

/**
 * 获得当前设备的唯一UUID
 */
const UUID_CACHE_KEY = "unique-udid";
tools.guid2 = function () {
    function S4() {
        return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
    }
    let udid = window.localStorage.getItem(UUID_CACHE_KEY);
    if (!udid) {
        udid = (S4() + S4() + "-" + S4() + "-" + S4() + "-" + S4() + "-" + S4() + S4() + S4());
        window.localStorage.setItem(UUID_CACHE_KEY, udid);
    }
    return udid;
}

/**
 * 获得当前设备信息
 * @param {*} self 
 */
tools.getDevice = function (self) {
    let device = self.$store.state.common.device;
    if (!device) {
        tools.getBaseInfo(dataConfig.device, self);
        self.$store.commit("common/setDevice", dataConfig.device);
        return dataConfig.device;
    } else {
        return device;
    }
}

/**
 * 判断是否为 苹果设备
 */
tools.isIos = function () {
    var u = navigator.userAgent;
    if (!u) {
        return false;
    }
    u = u.toLowerCase();
    if (u.indexOf("iphone") > -1 || u.indexOf("ios") > -1 || u.indexOf("ipad") > -1) {
        return true;
    }
    return false;
}

/**
 * 判断是否为PC设备
 */
tools.isPC = function () {
    var userAgentInfo = window.navigator.userAgent;
    var Agents = ["Android", "iPhone",
        "SymbianOS", "Windows Phone",
        "iPad", "iPod"];
    var flag = true;
    for (var v = 0; v < Agents.length; v++) {
        if (userAgentInfo.indexOf(Agents[v]) > 0) {
            flag = false;
            break;
        }
    }
    return flag;
}

/**
 * 密码规则
 * @param {*} password 
 */
tools.passwordRules = function (password) {
    let errType = true;
    let regex1 = ".*[a-zA-z].*";
    let regex2 = ".*[0-9].*";
    if (!password.match(regex1)) errType = false;
    if (!password.match(regex2)) errType = false;
    if (password.length < 6 || password.length > 16) errType = false;
    return errType;
}

/**
 * 当前时间格式化
 * @param {*} now 
 * @param {*} type 
 */
tools.formatDate = function (now, type) {
    let year = now.getFullYear();
    let month = now.getMonth() + 1;
    let date = now.getDate();
    let hour = now.getHours();
    let minute = now.getMinutes();
    let second = now.getSeconds();
    var zHour = "";
    var zMinute = "";
    var zSecond = "";
    if (hour < 10) {
        zHour = "0";
    }

    if (minute < 10) {
        zMinute = "0";
    }

    if (second < 10) {
        zSecond = "0";
    }

    if (type) {
        if (type == 1) {
            return year + "/" + month + "/" + date + "  " + zHour + hour + ":" + zMinute + minute;
        } else if (type == 2) {
            // 有换行的在，时分秒分开
            return year + "-" + month + "-" + date + "\n" + zHour + hour + ":" + zMinute + minute + ":" + zSecond + second;
        } else if (type == 3) {
            /**只显示年月日 */
            return year + "/" + month + "/" + date;
        } else if (type == 4) {
            /**只显示年月日 */
            return year + "." + month + "." + date;
        } else if (type == 5) {
            /**只显示年月日 */
            return hour + ":" + zMinute + minute + ":" + zSecond + second + "   " + date + "/" + month + "/" + year;
        }
    } else {
        return year + "-" + month + "-" + date + " " + zHour + hour + ":" + zMinute + minute + ":" + zSecond + second;
    }
}

/**
 * 数字格式化
 * @param {*} money 
 */
tools.formateNumber = function (money , isInt) {
    let NewMoney = '';
    let string = money.toString();
    //取出整数部分
    let strArr = string.split(".");
    string = strArr[0];

    let len = string.length;
    let num = Math.floor(string.length / 3);
    let one = string.length % 3 == 0;
    let max = 1;
    if (len <= 3) {
        NewMoney = string;
    } else {
        if (one == true) num--;
        for (let index = len - 1; index >= 0; index--) {
            NewMoney = string[index] + NewMoney;
            if (max == 3) {
                if (num != 0) {
                    NewMoney = ',' + NewMoney;
                    max = 0;
                    num--;
                }
            }
            max++;
        }
    }
    //添加小数部分
    if (strArr[1] && !isNaN(strArr[1])) {
        (strArr[1].length == 1) && (strArr[1] += "0"); 
        NewMoney += "." + strArr[1].substring(0, 2);
    } else {
        if (!isInt) NewMoney += ".00";
    }
    return NewMoney;
}

/**
 * 数字格式化
 * @param {*} num 
 * @param {*} ispad 
 */
tools.formateNumberByReg = function (num, ispad = false) {
    if (num == null || num == undefined || num == "") {
        return "";
    }
    let pad = 2;
    if (ispad) {
        pad = 0
    }
    if (isNaN(num)) return num;
    //alert(num);
    return (parseFloat(num).toFixed(pad) + '').replace(/\d{1,3}(?=(\d{3})+(\.\d*)?$)/g, '$&,');
    //return (toFixed(num,2) + '').replace(/\d{1,3}(?=(\d{3})+(\.\d*)?$)/g, '$&,');
}

/**
 * 获得cookie的值
 * @param {*} cookie_name 
 */
tools.get_cookie = function (cookie_name) {
    var results = document.cookie.match('(^|;) ?' + cookie_name + '=([^;]*)(;|$)');
    if (results)
        return (decodeURI(results[2]));
    else
        return null;
}

/**
 * 设置cookie
 * @param {*} name 
 * @param {*} value 
 * @param {*} exp_t 
 * @param {*} path 
 * @param {*} domain 
 * @param {*} secure 
 */
tools.set_cookie = function (name, value, exp_t, path, domain, secure) {
    var cookie_string = name + "=" + encodeURI(value);
    if (exp_t) {
        exp_t = (((new Date()).getTime() / 1000) + exp_t) * 1000;
        var expires = new Date();
        expires.setTime(exp_t);
        cookie_string += "; expires=" + expires.toGMTString();
    }
    if (path)
        cookie_string += "; path=" + encodeURI(path);

    if (domain)
        cookie_string += "; domain=" + encodeURI(domain);

    if (secure)
        cookie_string += "; secure";

    document.cookie = cookie_string;
}

/**
 * 删除cookie
 */
tools.delete_cookie = function (cookie_name) {
    var cookie_date = new Date();  // current date & time
    cookie_date.setTime(cookie_date.getTime() - 1);
    document.cookie = cookie_name += "=; expires=" + cookie_date.toGMTString();
}


/**
 * 格式化活动日期
 * @param {*} st 
 * @param {*} et 
 */
tools.formatActivityDate = function (st, et) {
    let MonthsShort = "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split(
        "_"
    );
    let nth = function (d) {
        if (d > 3 && d < 21) return 'th';
        switch (d % 10) {
            case 1: return "st";
            case 2: return "nd";
            case 3: return "rd";
            default: return "th";
        }
    }
    let pad = function (num, n) {
        return (Array(n).join(0) + num).slice(-n) + nth(num);
    };
    let sdate = new Date(st);
    let edate = new Date(et);

    let timeStr = `${pad(parseInt(sdate.getDate()), 2)} ${MonthsShort[parseInt(sdate.getMonth())]
        } -${pad(parseInt(edate.getDate()), 2)} ${MonthsShort[parseInt(edate.getMonth())]
        } ${edate.getFullYear()}`;
    return timeStr;
}

/**
 * 跳转页面
 * @param {*} self 
 * @param {*} query 
 * @param {boolean 是否强制} isforce 
 */
tools.toPage = function (self, query, isforce) {
    if (!isforce && self.$route.path == query.path) {
        console.log("no refresh");
        return;
    }
    //拼接google 分析 utm 链接
    if (!query.query) query.query = {};
    if (window.cnQuery) {
        for (let ckey in window.cnQuery) {
            query.query[ckey] = window.cnQuery[ckey];
        }
    }
    query.query['ver'] = httpConfig.widgetVersion;
    //本页跳转不需要loading
    if (self.$route.path != query.path) {
        this.setLoadingState(true);
    } else {
        //当前页面，则直接
        if (query.path == "/" && query.query['action'] == "login") {
            this.emit(eventConfig.LOGIN_PAGE);
            return;
        }
    }

    self.$router.push(query);
}

/**
 * 去空格
 * @param {*} str 
 */
tools.trimSpace = function (str) {
    if (!str) {
        return "";
    }
    str = str.replace(/^\s*|\s*$/g, "");
    if (str == "null" || str == "undefined") {
        return "";
    }
    return str;
}

/**
 * 深度拷贝
 * @param {*} target 
 */
tools.deepClone = function (target) {
    // 定义一个变量
    let result;
    // 如果当前需要深拷贝的是一个对象的话
    if (typeof target === "object") {
        // 如果是一个数组的话
        if (Array.isArray(target)) {
            result = []; // 将result赋值为一个数组，并且执行遍历
            for (let i in target) {
                // 递归克隆数组中的每一项
                result.push(tools.deepClone(target[i]));
            }
            // 判断如果当前的值是null的话；直接赋值为null
        } else if (target === null) {
            result = null;
            // 判断如果当前的值是一个RegExp对象的话，直接赋值
        } else if (target.constructor === RegExp) {
            result = target;
        } else {
            // 否则是普通对象，直接for in循环，递归赋值对象的所有值
            result = {};
            for (let i in target) {
                result[i] = tools.deepClone(target[i]);
            }
        }
        // 如果不是对象的话，就是基本数据类型，那么直接赋值
    } else {
        result = target;
    }
    // 返回最终结果
    return result;
}

/**
 * 获得平台来源
0	casino	最早期的app
1	casino	casino, h5 手机端
2	casino	casino, h5 电脑端
3	bet	bet, h5
4	casino	casino, lite app
5	casino	casino, 新原生app
6	bet	bet, lite app
7	bet	bet, 原生 app
8	bet	bet, 短信渠道充值
9	casino	casino,传音休闲版
11	bet	bet,ussd渠道充值
12	casino	casino,pwa版
13	bet	bet,pwa版
14	casino	casino,游戏内pwa
15	casino	casino,bet跳转
 * 
 */
tools.getPlatForm = function () {
    let platform = tools.isPC() ? 2 : 1;
    if (window.AndroidBridge) {
        platform = 4;
    } else if (window.isPwa) {
        platform = 12;
    }
    return platform;
}

/**
 * 活动跳转地址，如果为非当前域名则转换为当前域名 (主要本地开发是使用)
 * @param {*} url 
 */
tools.rechangeHost = function (url, newHost) {
    if (!url) {
        return "/";
    }
    let host = newHost ? newHost : (window.location.protocol + "//" + window.location.host + "/");
    // .com? 模式确认
    var urlArr = url.replace("/?", "?").split("?");
    if (urlArr[0].split("/").length <= 3 && !/[=&]/.test(urlArr[0])) {
        urlArr[0] = host;
        url = urlArr.join("?");
    } else {
        url = host + url.split("/").slice(3).join("/");
    }
    console.log(url);
    return url;
}

/**
 * 判断当前时间是否过期
 * @param {int 当前时间} stamp 
 * @param {*} sec 
 */
tools.isExpireTime = function (stamp, sec) {
    let now = Math.floor((new Date()).getTime() / 1000) - sec;
    if (stamp > now) {
        return false;
    }
    return true;
}

/**
 * 转换图片后缀
 * @param {string 图片地址} addr 
 */
tools.changeTowebp = function (addr) {
    if (addr && addr.match(/https?:\/\//)) {
        //预发布环境因为内网限制的问题，无法访问正式网图片，需要替换根域名路径
        if (window.preEvnPrefix && window.preEvnPrefix != "") {
            addr = tools.rechangeHost(addr);
        }
    } else {
        if (addr) {
            addr = this.getSiteResourceRoot() + addr;
        }
    }
    if (window.isWebp && typeof addr == "string") {
        addr = addr.replace("jpg", "webp");
        addr = addr.replace("png", "webp");
    }
    if (addr.indexOf("?") == -1) {
        addr += "?" + httpConfig.version;
    }
    return addr;
}

/**
 * 判断数据是否为http地址
 * @param {*} url 
 */
tools.isHttpUrl = function (url) {
    var pattern = new RegExp(
        '^(https?:\/\/)?'  // protocol
        // '((([a-z\d]([a-z\d-]*[a-z\d])*)\.)+[a-z]{2,}|'+ // domain name
        // '((\d{1,3}\.){3}\d{1,3}))'+ // OR ip (v4) address
        // '(\:\d+)?(\/[-a-z\d%_.~+]*)*'+ // port and path
        // '(\?[;&a-z\d%_.~+=-]*)?'+ // query string
        // '(\#[-a-z\d_]*)?$','i'); // fragment locater
    );
    return pattern.test(url);
}

/**
 * 确认是否需要更新的版本
 */
const UPDATER_DATE_KEY = "cancel-updater";
tools.checkIsNeedNewVersion = function () {
    if (!window.liteVer) {
        return false;
    }
    let liteVer = (window.liteVer + "").replace(".", "");
    let newVer = httpConfig.AndroidLiteVersion.replace(".", "");
    if (liteVer < newVer) {
        //当日已经选择过放弃，则不再弹出更新弹窗
        var date = (new Date()).getDate();
        var lastDate = window.localStorage.getItem(UPDATER_DATE_KEY);
        if (lastDate == date) {
            return false;
        }
        return true;
    } else {
        return false;
    }
}

/**
 * 取消更新
 */
tools.cancelUpdater = function () { window.localStorage.setItem(UPDATER_DATE_KEY, (new Date()).getDate()); }

/**
 * 测试线上环境判断
 */
tools.isOnlineEvn = function () {
    if (httpConfig.baseUrl().indexOf("gbank.team") != -1) {
        return false;
    } else {
        return true;
    }
}

/**
 * 设置loading状态
 * @param {*} status 
 */
tools.setLoadingState = function (status) { EventUtils.$emit("isInLoading", status); }

tools.getMoneyShower = function (self) {
    if (!self.$store.state.user || !self.$store.state.user.isLogin) {
        return " 0.00 ";
    }
    return this.formateNumber(self.$store.state.user.realUser.chip);
}

tools.getRemoteResourceRoot = function () { return (window.location.protocol + "//" + window.location.host); }
tools.getSiteResourceRoot = function () { return (window.location.protocol + "//" + window.location.host + httpConfig.localResPrefix); }

/**
 * event bus
 * @param {*} eventName 
 * @param {*} eventData 
 */
tools.emit = function (eventName, eventData) { EventUtils.$emit(eventName, eventData); }
tools.on = function (eventName, cb) { EventUtils.$on(eventName, cb); }
tools.off = function (eventName) { EventUtils.$off(eventName); }
tools.asyncEvent = function(callback , timeout) {
    if (!timeout && timeout < 20) timeout = 20; 
    let handler = setTimeout(() => {
        if (handler) clearTimeout(handler);
        handler = null;
        callback();
    }, timeout);
}

tools.getErrorInfo = function (self, errcode) {
    let key = "err." + errcode;
    let tips = self.$t(key);
    if (!tips || tips.indexOf("err.") != -1) {
        tips = self.$t("err.DEFAULT");
    }
    return tips;
}
tools.formateNumber1 = function (num, ispad = false) {
    if (num == null || num == undefined || num == "") {
        return "";
    }
    let pad = 2;
    if (ispad) {
        pad = 0
    }
    if (isNaN(num)) return num;
    //alert(num);
    return (parseFloat(num).toFixed(pad) + '').replace(/\d{1,3}(?=(\d{3})+(\.\d*)?$)/g, '$&,');
    //return (toFixed(num,2) + '').replace(/\d{1,3}(?=(\d{3})+(\.\d*)?$)/g, '$&,');
}

/**
 * 获得token 相关的信息
 * @param {*} self 
 */
tools.getLoginToken = function(self){
    let user = self.$store.state.user;
    let country = self.$store.state.common.country;
    let base = {
        isLogin:user.isLogin,
        isDemo:self.$store.getters["temp/isDemo"],
        country:country
    };
    let guestUser = self.$store.getters["user/getGuest"](country);
    if (guestUser) {
        base.demoToken = guestUser.token;
        base.demoSecretKey = guestUser.secretKey;
    };

    if (user.isLogin) {
        base.secretKey = user.realUser.secretKey,
        base.token = user.realUser.token  
    };

    return base;
};

/**
 *  无法完全唯一，只能作为一个补充方案
 */
tools.getUniqueId = function (country) {
    if (!country) country = "ke";
    function cans() {
        var canvas = document.createElement('canvas');
        var ctx = canvas.getContext('2d');
        var txt = tools.getSiteResourceRoot();
        ctx.textBaseline = "top";
        ctx.font = "14px 'Arial'";
        ctx.textBaseline = "bangbet";
        ctx.fillStyle = "#f60";
        ctx.fillRect(125, 1, 62, 20);
        ctx.fillStyle = "#069";
        ctx.fillText(txt, 2, 15);
        ctx.fillStyle = "rgba(102, 204, 0, 0.7)";
        ctx.fillText(txt, 4, 17);
        var b64 = canvas.toDataURL().replace("data:image/png;base64,", "");
        var bin = atob(b64);
        var crc = bin2hex(bin.slice(-16, -12));
        return crc;
    }

    function bin2hex(str) {
        var result = "";
        for (let i = 0; i < str.length; i++) result += int16_to_hex(str.charCodeAt(i));
        return result;
    }

    function int16_to_hex(i) {
        var result = i.toString(16);
        var j = 0;
        while (j + result.length < 4) { result = "0" + result; j++; }
        return result;
    }

    let param = {
        cavans: cans(),
        height: window.innerHeight || 0,
        width: window.innerWidth || 0,
        agent: window.navigator ? window.navigator.userAgent : Math.floor(Math.random() * 1000),
        lg: window.navigator ? window.navigator.language : Math.floor(Math.random() * 1000),
        ratio: window.devicePixelRatio,
        rd: Math.floor(Math.random() * 100000),
    }
    if (window.screen) {
        param['height'] = window.screen.height;
        param['width'] = window.screen.width;
    }
    let str = "";
    for (let key in param) {
        str += key + "=" + param[key] + "&";
    }
    let uniqueId = window.localStorage.getItem("unique-atid-" + country);
    if (!uniqueId) {
        uniqueId = md5(str).toString();
        window.localStorage.setItem("unique-atid-" + country, uniqueId);
    }
    return uniqueId;
}

/**
 * 是否为开发环境
 */
tools.isDev = function(){
    let host = window.location.host;
    let filters = [
        "localhost",
        "pre-",
        "gbank.team"
    ]; 
    for (let i = 0 ; i < filters.length ; i++) {
        if (host.indexOf(filters[i]) != -1) {
            return true;
        }
    }
    return false;
}

/**
 * 检测iframe id 是否为Tawk
 * @param {*} str 
 */
tools.checkTawkIdType = function(str){
    if (!str) {
        return false;
    }
    var arr = str.split("-");
    var isNumber = /^[0-9]+$/.test(arr[1]);
    var isAph = /^[0-9a-zA-Z]+$/.test(arr[0]);
    if (isNumber && isAph) {
        return true;
    } else {
        return false;
    }
}

/**
 * 打开livechat界面
 * @param {*} self 
 */
tools.toggleTawk = function(self){
    if (!window.Tawk_API) {
        return false;
    }
    let sUser = self.$store.state.user;
    if (!sUser.isLogin) {
        window.Tawk_API.addEvent('user-info', {
            'id'    : 'Tourist'
        }, function(error){

        });
    } else {
        let data =  {
            'id'    : sUser.realUser.id.toString(),
            'name'  : sUser.realUser.email.toString(),
            'class' : 'rummy'
        };
        window.Tawk_API.addEvent('user-info', data, function(error){
            console.log(error);
        });
    };
    window.Tawk_API.toggle();
    return true;
}

/**
 * 载入live chat
 */
tools.loadTawk = function(){
    let isLoaded = false;
    let iframes = document.getElementsByTagName("iframe");
    if (iframes) {
        for(let index in iframes) {
            if (iframes[index].id && this.checkTawkIdType(iframes[index].id)) {
                isLoaded = true;
                break;
            }
        }
    }
    if (!window.isLoadedTawk && !isLoaded) {
        var s1 = document.createElement("script"), s0 = document.getElementsByTagName("script")[0];
        s1.async = true;
        s1.src =  dataConfig.liveChat.embed;
        s1.charset = 'UTF-8';
        s1.setAttribute('crossorigin', '*');
        s0.parentNode.insertBefore(s1, s0);
        window.isLoadedTawk = true;
    }
}

/**
 * af 充值上报
 * @param {*} self 
 */
tools.setAfDepositeEvent = function(self) {
    let money = self.$store.getters["user/getPayMoney"];
    if (money) {
        self.$store.commit("user/setPayMoney" , 0);
        let af = {
            af_revenue:parseFloat(money),
            af_currency:"INR",
            af_quantity:1,
            af_content_id:"",
            order_id:"",
            af_receipt_id:""
        };
        window.AndroidBridge && window.AndroidBridge.afPurchase && window.AndroidBridge.afPurchase(JSON.stringify(af));
    }    
}

tools.removeSpace = function(str) {
    return str.replace(/\s*/g,"");
}

tools.checkEzpay = function(str , type){
    if (!str) {
        return false;
    }
    str = tools.removeSpace(str);
    if (str.split("").length < 3) {
        return false;
    }
    if (type == 'email') {
        var reg = /^([a-zA-Z]|[0-9])(\w|\-|\_)+@[a-zA-Z0-9]+\.([a-zA-Z\.]{2,8})$/;
        if (!reg.test(str)) {
            return false;
        }      
    }
    return true;
}

/**
 * 确认是否正常
 * @param {*} isfc 
 */
tools.checkIsfc = function(isfc) {
    if (!isfc) {
        return false;
    }
    let head = isfc.substring(0 , 4);
    if (head.length == 4 &&  !/^[a-zA-Z]+$/.test(head)) {
        return false;
    }
    let end = isfc.substring(4);
    if (!/^[0-9]+$/.test(end)) {
        return false;
    }
    if (isfc.split("").length != 11) {
        return false;
    }
    return true;
}

export default tools;



// WEBPACK FOOTER //
// ./src/utils/fun.js